import React from 'react';

export const Sold = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4762 10.7418V5C21.4762 3.89543 20.5808 3 19.4762 3H13.3284C12.798 3 12.2893 3.21071 11.9142 3.58579L3.42408 12.0759C2.63919 12.8608 2.64362 14.1347 3.43395 14.9141L9.23467 20.6347C10.0055 21.3949 11.2412 21.4038 12.0228 20.6547L20.86 12.1858C21.2536 11.8085 21.4762 11.287 21.4762 10.7418Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <circle cx="16" cy="8" r="2" stroke="black" strokeWidth="1.5" />
  </svg>
);
